import { mockData } from "./Mock";
import { IdentityAudit } from "../../models/IdentityAudit";

const imageMock = (label: string) =>
    `https://via.placeholder.com/300x400/4CAF50/FFFFFF?text=${encodeURIComponent(label)}`;

const mockCandidates: IdentityAudit[] = [
    {
        id: "IA001",
        userId: "S001",
        userType: 1,
        userName: "测试卖家1",
        realName: "张三",
        idCardNumber: "110101199001011234",
        idCardFront: imageMock("正面1"),
        idCardBack: imageMock("反面1"),
        selfieWithIdCard: imageMock("手持1"),
        status: "processing",
        applyTime: "2024-03-15 10:00:00"
    },
    {
        id: "IA002",
        userId: "B001",
        userType: 2,
        userName: "测试买家1",
        realName: "李四",
        idCardNumber: "110101199002021234",
        photoUrl: imageMock("买家照2"),
        status: "processing",
        applyTime: "2024-03-15 09:30:00"
    },
    {
        id: "IA003",
        userId: "S002",
        userType: 1,
        userName: "测试卖家2",
        realName: "王五",
        idCardNumber: "110101199003031234",
        idCardFront: imageMock("正面3"),
        idCardBack: imageMock("反面3"),
        selfieWithIdCard: imageMock("手持3"),
        status: "processing",
        reason: "身份证照片不清晰，请重新上传",
        applyTime: "2024-03-15 08:45:00"
    }
];

const mockProcessed: IdentityAudit[] = [
    {
        id: "IA004",
        userId: "S003",
        userType: 1,
        userName: "已审核卖家1",
        realName: "赵六",
        idCardNumber: "110101199004041234",
        idCardFront: imageMock("正面4"),
        idCardBack: imageMock("反面4"),
        selfieWithIdCard: imageMock("手持4"),
        status: "approved",
        result: "approved",
        applyTime: "2024-03-14 15:20:00",
        auditTime: "2024-03-14 16:30:00"
    },
    {
        id: "IA005",
        userId: "B002",
        userType: 2,
        userName: "已审核买家1",
        realName: "钱七",
        idCardNumber: "110101199005051234",
        photoUrl: imageMock("买家照5"),
        status: "rejected",
        result: "rejected",
        reason: "证件信息不匹配",
        applyTime: "2024-03-14 14:10:00",
        auditTime: "2024-03-14 15:45:00"
    }
];

mockData.set("identity_audit_candidates", mockCandidates);
mockData.set("identity_audit_processed", mockProcessed);
